import PermissionGuard from 'components/Global/PermissionGuard'; 
import EmployeeMapping from 'components/EmployeeMapping';

export const EmployeeMappingPage = () => {
	return (
		<PermissionGuard permission="Allow_Employee_Mapping">
			<EmployeeMapping />
		</PermissionGuard>
	);
};
